module.exports = __webpack_public_path__ + "static/media/money-icon-active.860a10ff.svg";